import type { PopupWithCampaignResponse } from '@coorum-research/shared-common/api-response/popup.schema'
import { useMemo, useState } from 'react'
import { type SuspendConfig, getSuspendingRecords, setSuspendRecord } from '../utils/suspend-storage.util'

export function usePopupSuspends(popups?: PopupWithCampaignResponse[]) {
  const [refreshPopups, setRefreshPopups] = useState<number>(0)
  const { popupsOpen, popupsClosed, popupsReady } = useMemo(() => {
    if (!popups) {
      return { popupsReady: false }
    }

    const suspendConfigs = popups.map((popup) => {
      return {
        id: popup.id,
        suspendSeconds: popup.suspendSeconds,
      } satisfies SuspendConfig
    })
    const excludedIds = getSuspendingRecords(suspendConfigs).map(({ id }) => id)

    return {
      popupsOpen: popups.filter(({ id }) => !excludedIds.includes(id)),
      popupsClosed: popups.filter(({ id }) => excludedIds.includes(id)),
      popupsReady: true,
    }
  }, [popups, refreshPopups])

  const appendSuspendRecord = (popupId: string) => {
    setSuspendRecord({ id: popupId, suspendedAt: new Date().toISOString() })
    setRefreshPopups((i) => i + 1)
  }

  return {
    popupsOpen,
    popupsClosed,
    popupsReady,
    appendSuspendRecord,
  }
}
